import { render } from "./GuestNavbar.vue?vue&type=template&id=46ddbcdf&scoped=true"
const script = {}

import "./GuestNavbar.vue?vue&type=style&index=0&id=46ddbcdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ddbcdf"]])

export default __exports__